import React from 'react'
import {
  IconWarning,
  IconSize
} from '@contrast-security-inc/design-system-foundations'
import { Placement } from '../../legacy-design-system/popper'
import { AppInstrumentationTooltipContent } from '../servers-grid/app-instrumentation-tooltip'
import { Tooltip } from '@contrast-security-inc/design-system-popovers'
import { css } from '@emotion/css'

export const appInstrumentationTooltipTestId =
  'app-instrumentation-tooltip-test-id'

interface AppInstrumentationTooltipProps {
  applicationName: string
}

interface AppInstrumentationIconProps {
  placement?: Placement
  size?: IconSize
}

export function SkeletorAppInstrumentationTooltip({
  applicationName,
  placement,
  size
}: AppInstrumentationTooltipProps & AppInstrumentationIconProps) {
  return (
    <Tooltip
      placement={placement}
      className={css`
        z-index: 1003;
      `}
      body={
        <AppInstrumentationTooltipContent applicationName={applicationName} />
      }
    >
      <span>
        <IconWarning
          testId={appInstrumentationTooltipTestId}
          size={size}
          color="red50"
        />
      </span>
    </Tooltip>
  )
}
